import {useComputed} from "@preact/signals-react";
import {isEmpty, postSubmit} from "@ui-seeker/utils"

import {BACKEND_APIS} from "@constants";
import {useUserApp} from "@hooks";
import {brandForm, newProductsLoadingRow, newProductsMultipleRowsEdit, newProductsMultipleRowsSend, newProductsRowEditClicked, newProductsTableData, skuForm} from "../@signals";


export default function useUnmatchedNewProductsMappingForm(dataRow={}) {
	const { username } = useUserApp()

	const formData = useComputed(() => {
		if (newProductsTableData.value === null) {
			return {}
		}

		return newProductsTableData.value.filter(item => item.key === newProductsRowEditClicked.value)[0] || {}
	})

	const saveNewMapping = (__, notFound = false) => {
		newProductsLoadingRow.value = [...newProductsLoadingRow.value, formData.value.key]
		postSubmit(`${BACKEND_APIS.UNMATCHED}/new-products/update-mapping`, {
			brandID: brandForm.value,
			skuID: skuForm.value,
			productID: formData.value?.productID,
			siteID: formData.value?.siteID,
			skip: notFound,
			validated: true,
			qa: true,
			username: username,
			rowKey: formData.value.key
		}).then((res) => {
			newProductsTableData.value = newProductsTableData.value.filter(row => row.key !== res.rowKey)
			newProductsLoadingRow.value = [...newProductsLoadingRow.value.filter(key => key !== res.rowKey)]
		}).catch(() => console.log('ERROR EXTERNAL MAPPING SKU'))
	}

	const saveMultipleNewMapping = (__, notFound = false) => {
		newProductsLoadingRow.value = [...newProductsLoadingRow.value, ...newProductsMultipleRowsEdit.value.map((row => row.key))]
		postSubmit(`${BACKEND_APIS.UNMATCHED}/new-products/multiple-update-mapping`, {
			brandID: brandForm.value,
			skuID: skuForm.value,
			productsData: newProductsMultipleRowsEdit.value,
			skip: notFound,
			validated: true,
			qa: true,
			username: username,
		}).then((res) => {
			newProductsTableData.value = newProductsTableData.value.filter(row => !res.rowKeys.includes(row.key))
			newProductsMultipleRowsSend.value = res.rowKeys 
			newProductsLoadingRow.value = [...newProductsLoadingRow.value.filter(key => !res.rowKeys.includes(key))]
		}).catch(() => console.log('ERROR EXTERNAL MAPPING SKU'))
	}

	return {
		showForm: !isEmpty(formData.value) || newProductsMultipleRowsEdit.value.length > 0,
		formData: formData.value,
		formTitle: formData.value?.productTitle || `${newProductsMultipleRowsEdit.value.length} Products` ,
		isMultipleMapping: newProductsMultipleRowsEdit.value.length > 0,
		saveNewMapping,
		saveMultipleNewMapping
	}
}